import React, { useEffect } from 'react';
import '../styles/About.css';

const AboutPage = () => {
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-scroll');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="about-page">
      <h1 className="title">
        About My Media Database
      </h1>

      <div className="animate-on-scroll hero-section">
        {/* <img
          src="/static/images/anime-beginnings.jpg"
          alt="Anime beginnings"
          className="section-image"
        /> */}
        <div className="card">
          <p className="card-text">
            Welcome to my little corner of the internet, a personal media sanctuary! 
            Tracking the things I love: anime, manga, games, music, movies, and more. 
            This site actually has a bit of history; it did't just pop into existence overnight.
            It all started with a simple Excel sheet and grew into something much bigger.
          </p>
        </div>
      </div>

      <section className="content-sections">
        <div className="animate-on-scroll section">
          <img
            src="/static/images/excel-beginnings.png"
            alt="Excel tracker"
            className="section-image"
          />
          <div className="card">
            <h2 className="card-title">
              The Anime Spark (2016)
            </h2>
            <p className="card-text">
              I don't know the date, but it started around 2016 when I dove into anime with <em>Fairy Tail</em>, a massive 200+ episode series. 
              I had a simple rule: finish one anime before starting another. Well, with <em>Fairy Tail</em> being my first anime, 
              it didn't take too long for me to break my one rule. So I would "exempt" <em>Fairy Tail</em> from that rule.
              Which also only lasted so long. Before I knew it, I was juggling multiple series at once.
              So, I turned to Excel and created a simple table for titles, scores, and seasons,
              Just enough to keep track of what I was watching.
              Didn't take too long for me to start expanding on it, I was making this in excel, how could I not add graphs and statistics.
              I spend a long time working on this one excel function, displaying colors and icons to show what I had watched, started, or left untouched. 
              It was my first step into organizing my media obsession.
            </p>
          </div>
        </div>

        <div className="animate-on-scroll section reverse">
          <img
            src="/static/images/excel-expantions.png"
            alt="Excel Manga and movies"
            className="section-image"
          />
          <div className="card">
            <h2 className="card-title">
              Growing the Collection
            </h2>
            <p className="card-text">
              A few years later, my Excel sheet evolved. I added sections for anime movies, 
              keeping them separate from series, and manga, as I started exploring that medium too. 
              I spent hours crafting formulas and visuals, with colors for completed seasons, unstarted series, 
              and everything in between. This was all before I discovered MyAnimeList (MAL). 
              If I had known about the existence of MAL, I might've never started keeping track of my anime and manga.
              But my spreadsheet was a labor of love, and I was proud of every cell.
              It proved to be useful multiple times — whether for keeping track or giving recommendations.
              I never had to struggle to recall the series I had seen or watched.
            </p>
          </div>
        </div>

        <div className="animate-on-scroll section">
          <img
            src="/static/images/godot-app.png"
            alt="Godot app"
            className="section-image"
          />
          <div className="card">
            <h2 className="card-title">
              Going Godot (2022)
            </h2>
            <p className="card-text">
              By around 2022, Excel felt limiting. I wanted images, metadata, and automation,
              but I refused to abandon the system I had grown to love; grouping seasons under a single anime entry,
              which was unlike MAL's approach.
              So, I opened Godot, my everything-tool at the time, and built a desktop app. Discovering MAL's API was a revelation.              I added genres, studio info, added my own color-coded system similair to what I had, even enabling per-season ratings. 
              Sorting and filtering never got finished but were planned. The search feature, however, was implemented, and I was thrilled with the result;
              I could quickly search for anime and manga by genre, title, studio, etc.
              To sync between my desktop and laptop, I added support for setting a custom file location.
              This let me effortlessly use OneDrive to sync data between devices without any extra work.
            </p>
          </div>
        </div>

        <div className="animate-on-scroll section reverse">
          <img
            src="/static/images/steam-collection.png"
            alt="Steam collection"
            className="section-image"
          />
          <div className="card">
            <h2 className="card-title">
              Games and Domains
            </h2>
            <p className="card-text">
              Meanwhile, to sidetrack for a bit, my Steam library was growing, and I wanted to track completed games.
              With the size of my library, it was difficult to remember which games I had actually completed.
              So I made a collection in Steam so I could add games to it once I fi nished them.
              And while it worked, I was never truly happy with the system.
              I wanted the ability to rate my games, just like I did with anime, and a Steam collection just didn't cut it.
              At this point, I was already thinking about ways to build a similar app, but instead of using MAL, I would implement Steam's API.              
              <br/> <br/>
              I also bought a domain around this time: <strong>Jessai.nl</strong>. Seeing it was available and not too expensive, I decided to grab it.
              But that left me wanting something a bit less professional, so I also bought <strong>y02.nl</strong> —
              a short version of my username, yes102, meant for personal use. It's catchy and tied to my digital identity.
              <br/> <br/>
              But while I bought these domains, 
              they would not see any use untill at least a year later where I tried making some initial attempts at making my portfolio for Jessai.nl.
              However these pages were simple and hosted using github pages. A simple free hosting option, but not suitable hosting backend.
              
            </p>
          </div>
        </div>

        <div className="animate-on-scroll section">
          <img
            src="/static/images/media-database.png"
            alt="Media Database Development"
            className="section-image"
          />
          <div className="card">
            <h2 className="card-title">
              The Web Transformation (2025)
            </h2>
            <p className="card-text">
              Start of 2025, I found myself getting into collecting physical games and I bought a PSP and, naturally, made another Excel sheet to track them.
              <br/> <br/>
              But then I discovered web development, how to work with a proper frontend and backend; 
              Not just exporting a godot project using a html template.
              My Godot app, reliant on a shared OneDrive for data, wasn't mobile-friendly or ideal. 
              I decided to rebuild it as a web app, self-hosted for full control. 
              I adapted the Godot layout and visual style, I kept the expandable view, but diched the old color-coding in favor of a tags system. 
              I integrated my Steam library but while realized it didn't cover many games like <em>OutRun 2006</em> or <em>Professor Layton</em>. 
              That's when I found IGDB's API, which had everything I needed.
            </p>
          </div>
        </div>

        <div className="animate-on-scroll section reverse">
          <img
            src="/static/images/media-database-homepage.png"
            alt="Media sanctuary"
            className="section-image"
          />
          <div className="card">
            <h2 className="card-title">
              Building the full Media Database
            </h2>
            <p className="card-text">
              The app grew from there. I added a homepage. Made a dedicated media page for each media item. Added my vinyl and CD collection via Discogs. 
              And initially I was against adding movies, since there would be no way for me to in hinesight add all movies I have seen; Unlike anime, 
              which I tracked from the start; But eventually I bite the bullet, and I also added non-anime movies and TV shows using TMDB. 
              <br/> <br/>
              What began as an Excel sheet in 2016 is now a fully self-hosted, mobile-friendly web app that tracks 
              my anime, manga, games (Steam and beyond), music, movies, and shows, all tailored to my vision. 
              And besides being accessible from anywhere, it now was also accessible by anyone. No account needed.
            </p>
          </div>
        </div>

        <div className="animate-on-scroll final-note">
          <div className="card">
            <p className="card-text final-text">
              This is my media sanctuary, built from a love of anime, games, music and other media. Thanks for stopping by!
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;